import { IConversationSuggestion, ISuggestedFaqDetails } from '@/models/suggestedFaq.model';

export const updateConversationSuggestions = (
  suggestions: IConversationSuggestion[] | undefined,
  updatedSuggestion: ISuggestedFaqDetails,
): IConversationSuggestion[] | undefined =>
  suggestions?.map((suggestion) =>
    suggestion.reviewId === updatedSuggestion.reviewId ? { ...suggestion, ...updatedSuggestion } : suggestion,
  );
